export const dashboardStats = {
  totalUsers: 128456,
  residentUsers: 115230,
  commercialUsers: 13226,
  monthlyRevenue: 8562340.50,
  monthlyGasVolume: 2856320.5,
  activeDevices: 142568,
  alarmCount: 23,
  pendingInspection: 156,
  revenueGrowth: 12.5,
  volumeGrowth: 8.3,
};

export const revenueChartData = [
  { month: "1月", revenue: 7256320, volume: 2456320 },
  { month: "2月", revenue: 6856210, volume: 2256210 },
  { month: "3月", revenue: 7156320, volume: 2356320 },
  { month: "4月", revenue: 7456210, volume: 2456210 },
  { month: "5月", revenue: 7856320, volume: 2556320 },
  { month: "6月", revenue: 8056210, volume: 2656210 },
  { month: "7月", revenue: 7756320, volume: 2556320 },
  { month: "8月", revenue: 8156210, volume: 2656210 },
  { month: "9月", revenue: 8356320, volume: 2756320 },
  { month: "10月", revenue: 8456210, volume: 2756210 },
  { month: "11月", revenue: 8256320, volume: 2756320 },
  { month: "12月", revenue: 8562340, volume: 2856320 },
];

export const alarmList = [
  { id: "AL001", userId: "R002", userName: "李秀梅", type: "低余额预警", level: "warning", time: "2026-04-10 09:23:15", status: "未处理" },
  { id: "AL002", userId: "C001", userName: "老北京涮肉馆", type: "压力异常", level: "danger", time: "2026-04-10 08:45:32", status: "处理中" },
  { id: "AL003", userId: "R001", userName: "张建国", type: "设备校验到期", level: "info", time: "2026-04-10 07:30:00", status: "未处理" },
  { id: "AL004", userId: "C002", userName: "北京华联超市", type: "用气量异常", level: "warning", time: "2026-04-09 22:15:48", status: "已处理" },
  { id: "AL005", userId: "R003", userName: "王大明", type: "安检逾期提醒", level: "info", time: "2026-04-09 18:00:00", status: "未处理" },
];

export const iotDeviceStats = {
  online: 138562,
  offline: 2856,
  alarm: 23,
  maintenance: 1127,
};
